import { useState, useEffect } from 'react';
import { useWebSocket } from './WebSocketContext';

/**
 * Hook to fetch and manage folder restriction settings for a case
 * Returns restriction state that can be passed to useFolderPicker
 */
export function useFolderRestrictions(caseid) {
  const { ws, subscribeToMessages } = useWebSocket();
  const [restrictToUserFolder, setRestrictToUserFolder] = useState(false);
  const [allowedRoots, setAllowedRoots] = useState([]);
  const [displayRoot, setDisplayRoot] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!ws || !caseid) {
      setLoading(false);
      return;
    }

    // Subscribe to getFoldersSettings response
    const unsubscribe = subscribeToMessages((parsedMessage) => {
      if (parsedMessage.command === 'getFoldersSettings') {
        const data = parsedMessage.data || {};
        setRestrictToUserFolder(data.restrictToUserFolder || false);
        setAllowedRoots(data.allowedRoots || []);
        setDisplayRoot(data.displayRoot || '');
        setLoading(false);
      }
    });

    // Request folder settings
    const message = {
      command: 'getFoldersSettings',
      caseid: caseid
    };
    ws.send(JSON.stringify(message));

    return unsubscribe;
  }, [ws, caseid, subscribeToMessages]);

  return {
    restrictToUserFolder,
    allowedRoots,
    displayRoot,
    loading
  };
}
